import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Position } from '../types';
import { PopoverBackground, PopoverBorder, PopoverPointerPosition } from './popover.enums';

@Component({
  selector: 'wfm-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoverComponent {
  @Input() position: Position = Position.right;

  @Input() border: PopoverBorder = PopoverBorder.default;

  @Input() background: PopoverBackground = PopoverBackground.default;

  @Input() width = '';

  @Input() pointerPosition: PopoverPointerPosition = PopoverPointerPosition.center;

  @Input() isHeading = false;

  @Input() headingText = '';

  @Input() manualTrigger = false;

  @Output() openChange = new EventEmitter<boolean>();
  private $open = false;

  @Input() set open(v: boolean) {
    const open = this.$open;
    this.$open = v;
    open !== v && this.openChange.emit(this.$open);
  }
  get open(): boolean {
    return this.$open;
  }

  clickTrigger() {
    if (!this.manualTrigger) {
      this.open = true;
    }
  }

  get popoverClass(): string[] {
    const pointer = this.pointerPosition === PopoverPointerPosition.center ? '' : `-${this.pointerPosition}`;
    const classes = [`popover--${this.position}${pointer}`];

    if (this.border !== PopoverBorder.default) {
      classes.push(`popover--border-${this.border}`);
    }

    if (this.background !== PopoverBackground.default) {
      classes.push(`popover--background-${this.background}`);
    }

    return classes;
  }

  get widthStyle(): any {
    return (this.width && { width: this.width }) || {};
  }
}
